import { Button } from '@material-ui/core';
import React from 'react';

const UploadOfferExcelButton = ({
    eachData,
    handleOpenModal
}) => {

    return (
        <>
            <Button onClick={handleOpenModal(eachData)} style={{ textTransform: 'capitalize' }} variant='contained' size='small'>Upload File</Button>
        </>
    )
}

export default UploadOfferExcelButton